import {Main} from '../../components/main/main.tsx';
import {__} from '../../support/lang/translations.ts';
import {Hero} from '../../components/hero/hero.tsx';
import {useAppSelector} from '../../store/store.ts';
import {Tabs} from '../../components/tabs/tabs.tsx';
import {useIsNavigatingOrPending} from '../../support/use_is_navigating_or_pending.ts';
import {General} from './tabs/general.tsx';
import {Address} from './tabs/addres.tsx';
import {OpeningHours} from './tabs/opening_hours.tsx';
import mainStyles from '../../components/main/main.module.scss';
import {Page} from '../../components/page/page.tsx';
import {HeroSelect} from '../../components/hero/hero_select.tsx';
import {useState} from 'react';
import {LocationType} from '../../gql/customer/graphql.ts';

export function Contact() {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const defaultLocationId = meData?.default_location_id;
    const locations = useAppSelector((state) => state.appConfig.locations);
    const defaultLocation = locations
        ? defaultLocationId
            ? locations?.filter((l) => l?.id === defaultLocationId)[0]
            : locations.length > 0
              ? locations[0]
              : null
        : null;

    const [selectedLocation, setSelectedLocation] = useState<LocationType | null | undefined>(defaultLocation);

    return (
        <Main className={mainStyles.bg_white}>
            <Hero url={selectedLocation?.photo_url} hasSelect={true}>
                {locations && locations.length > 0 ? (
                    <HeroSelect
                        name={selectedLocation?.name ?? ''}
                        locations={locations}
                        selectedLocationId={selectedLocation?.id}
                        onClick={setSelectedLocation}
                    />
                ) : null}
            </Hero>

            {selectedLocation ? (
                <Page style={{paddingTop: 0}} isLoading={isLoading}>
                    <Tabs
                        disabled={isLoading}
                        name="general"
                        tabs={[
                            {
                                id: 'general',
                                link: <span>{__('contact.tabs.general')}</span>,
                                child: <General location={selectedLocation} />,
                            },
                            {
                                id: 'address',
                                link: <span>{__('contact.tabs.address')}</span>,
                                child: <Address location={selectedLocation} />,
                            },
                            {
                                id: 'opening_hours',
                                link: <span>{__('contact.tabs.opening_hours')}</span>,
                                child: <OpeningHours location={selectedLocation} />,
                            },
                        ]}
                    />
                </Page>
            ) : null}
        </Main>
    );
}
